<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="pageinfo.banner" /></div>
        </div>
        <div class="navinfowconrap">
            <div class="infowrapcollege">
                <div class="infotypecollege" v-if="$common.basic.isarrayexist(infolist)" v-for="item in infolist" :key="item.id">
                    <div class="infobox realwrap">
                        <div class="title" v-if="item.infotypekv<3"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div><div class="line"><span></span></div></div>

                        <div class="infostu1" v-if="item.infotypekv==1">
                            <div class="infostu1item" v-for="item2 in item.x_children" :key="item2.id">
                                <div class="infostu1img">
                                    <div class="infostu1imgbg"></div>
                                    <img :src="item2.img" />
                                </div>
                                <div class="infostu1con editor2">
                                    <span v-html="$common.langinfo(item2.content,item2.content_en)"></span>
                                    <div class="infostu1conname">—— {{$common.langinfo(item2.title,item2.title_en)}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="infostu2" v-else-if="item.infotypekv==2">
                            <dl>
                                <dd class="infostu2item" v-for="(item2,index2) in item.x_imgs" :key="index2">
                                    <img :src="item2" />
                                </dd>
                                <dd></dd>
                                <dd></dd>
                                <dd></dd>
                            </dl>

                        </div>

                        <div class="infostu3" v-else-if="item.infotypekv==3">
                            <img :src="item.imgs" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {
                pageinfo: {},
                infolist: []
            };
        },
        mounted() {

            this.$common.fetch({ 'act': 'tc_student' }, res => {
                this.pageinfo = res.infodata;

                this.$common.each(res.infodatainfo, (item) => {
                    item.x_imgs = [];
                    if (item.imgs) {
                        item.x_imgs = item.imgs.split(',');
                    }
                    item.x_children = res.infodatainfosub.filter(item2 => item2.infoid == item.id);
                });
                this.infolist = res.infodatainfo;
            });
        }
    }
</script>
